import {getUserConfig} from "@utility/utils";

const initialState = {
    list: [],
    total: 0,
    loading: false,
    searching: false,
    submitting: false,
    searchParams: {
        refresh: false,
        status: "",
        operatorID: "",
        start_date: "",
        end_date: "",
        page: 1,
        count: 30,
        ...getUserConfig("activityData")
    }
}

const activityReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ACTIVITY_DATA':
            return {
                ...state,
                ...action.payload
            }
        case 'ACTIVITY_DATA_RELOAD':
            return {
                ...state,
                searchParams: {
                    ...state.searchParams,
                    refresh: true
                }
            }
        case 'ACTIVITY_DATA_INIT':
            return {
                ...initialState,
                searchParams: {
                    ...initialState.searchParams,
                    ...getUserConfig("activityData")
                }
            }
        default:
            return {...state};
    }
}

export default activityReducer
